/**
 * 外部リンク・社内リンク・ローカル実行系の共通ユーティリティ。
 *
 * VB.NET版(デスクトップアプリ)では Process.Start でURLを開いたり、社内共有の
 * bat/exe を直接起動していた。Webブラウザからはローカルの bat/exe を起動できない
 * (全ブラウザのセキュリティ制約)ため、以下の方針とする:
 *   - http(s) のURL → 新しいタブで開く
 *   - bat/exe/UNCパス → パス文字列をクリップボードにコピーし、手元で実行してもらう
 */
import { useToastStore } from '@/stores/toast'

/** http(s) URLを新しいタブで開く(社内HTTP(192.168.x.x)含む) */
export function openExternal(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer')
}

/** bat/exe/UNCパスをクリップボードにコピーする。成功/失敗をアラートで通知。 */
export async function copyPath(path: string): Promise<void> {
  const toast = useToastStore()
  try {
    await navigator.clipboard.writeText(path)
    toast.show('実行パスをコピーしました。エクスプローラー等に貼り付けて実行してください。')
  } catch {
    // クリップボードAPIが使えない環境向けのフォールバック。この場合はコピーできていないため
    // パス自体を見せる必要があり、非同期のトーストだけでは不十分なのでpromptを維持する。
    window.prompt('クリップボードにコピーできませんでした。以下のパスを手動でコピーしてください:', path)
  }
}
